import React, { useState, useEffect } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { Loading } from "../atoms";
import { isEmpty } from "lodash";
import { signInWeb } from "../utils/Actions";
import RecoverPassword from "./RecoverPassword";
import { useHistory } from "react-router-dom";

function Copyright() {
  return (
    <Typography
      variant="body2"
      color="textSecondary"
      align="center"
      style={{ color: "#fff" }}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://www.sayeretsecurity.net/">
        Sayeret Security
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#fff",
    padding: 30,
    borderRadius: 30,
  },
  separator: {
    paddingTop: 50,
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const initialstate = {
  user: "",
  password: "",
};

export default function SignIn() {
  const classes = useStyles();
  const [state, setstate] = useState(initialstate);
  const [visible, setVisible] = useState(false);
  const [recover, setrecover] = useState(false);
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });

  let history = useHistory();

  useEffect(() => {
    function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }
    window.addEventListener("resize", handleResize);
  });

  const onChange = (e) =>
    setstate({ ...state, [e.target.name]: e.target.value });

  const _save = async () => {
    const { user, password } = state;

    if (isEmpty(user)) {
      alert("Debe ingresar su nombre de usuario");
    } else if (isEmpty(password)) {
      alert("Debe ingresar su contraseña");
    } else {
      setVisible(true);

      const { statusresponse, data } = await signInWeb(
        user.trim().toLowerCase(),
        password.trim()
      );

      if (statusresponse) {
        localStorage.setItem("Account", JSON.stringify(data));
        history.push("/");
      } else {
        alert("Usuario o contraseña incorrecta, favor inténtelo nuevamente");
      }
      setVisible(false);
    }
  };

  return (
    <div
      style={{
        background: `url('https://firebasestorage.googleapis.com/v0/b/sayeret-1aba9.appspot.com/o/fondodos.jpg?alt=media&token=2e0c8187-3749-4bf0-99bd-6099fb0d534d') no-repeat center center fixed`,
        backgroundSize: "cover",
        /* Full height */
        height: dimensions.height,
        width: dimensions.width,

        zIndex: 1,
      }}
    >
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.separator}>
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              SISTEMA WEB SAYERET
            </Typography>
            <form className={classes.form} noValidate>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Usuario"
                name="user"
                autoComplete="email"
                autoFocus
                onChange={onChange}
                value={state.user}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Contraseña"
                type="password"
                id="password"
                autoComplete="current-password"
                value={state.password}
                onChange={onChange}
              />

              <Button
                fullWidth
                variant="contained"
                color="secondary"
                className={classes.submit}
                onClick={_save}
              >
                INICIAR SESIÓN
              </Button>
              <Grid container>
                <Grid item xs>
                  <Link
                    variant="body2"
                    onClick={() => {
                      setrecover(true);
                    }}
                  >
                    ¿Olvidó la contraseña?
                  </Link>
                </Grid>
              </Grid>
            </form>
          </div>
        </div>
        <Box mt={8}>
          <Copyright />
        </Box>
        <Loading visible={visible} setVisible={setVisible} />
        <RecoverPassword visible={recover} setVisible={setrecover} />
      </Container>
    </div>
  );
}
